<script>
  import { navigate } from "svelte-routing";

  import Conexoes from "../../Classes/Conexoes.js";
  import ArmazenaVariaveisLogin from "../../Classes/ArmazenaVariaveisLogin.js";
  import Permissoes from "../../Classes/ArmazenaPermissoesUsuario.js";
  import Constantes from "../../Classes/Constantes.js";
  import { logado, atualizarLogado } from "../../Classes/EstadoLogado.js";
  import { Paper } from "@svelteuidev/core";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import { onMount, createEventDispatcher, onDestroy } from "svelte";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import ModalCadastro from "../../componentes_basicos/ModalCadastro.svelte";

  import {
    permissaoUsuario,
    permissaoPlataforma,
    DadosGenericos,
    DadosPaginaAnterior,
    DadosLogin,
    ConfirmaEmail,
  } from "../../Classes/Stores.js";
  import ModalConfirmaToken from "../../componentes_basicos/ModalConfirmaToken.svelte";
  import ModalEsqueciSenha from "../../componentes_basicos/ModalEsqueciSenha.svelte";
  const dispatch = createEventDispatcher();
  let esqueciASenha = false;
  let confirmar = false;
  let logadoValor; // Variável local para armazenar o valor de logado

  // Assine as mudanças no valor de logado
  const unsubscribe = logado.subscribe((value) => {
    logadoValor = value;
  });
  let username = "";
  let password = "";
  let retorno = "";
  let mensagem = "";
  let conexoes = new Conexoes(Constantes.url_base_nutri);
  let token = "";
  let id_empresa = "";
  let usuario = "";
  let showModal = false;
  let carregando = false;
  const api = "acesso.php";
  let parametros = {
    query_code: "acesso",
    usuario: username,
    senha: password,
  };

  let mostrarSenha = false;

  function togglePasswordVisibility() {
    mostrarSenha = !mostrarSenha;
  }
  function esperarMudancaDeEstado(store, condicao) {
    return new Promise((resolve) => {
      const unsubscribe = store.subscribe((value) => {
        if (value.email_confirmado === true) {
          unsubscribe();
          resolve(value);
        }
      });
    });
  }
  async function handleSubmit() {
    mensagem = "";

    if (username.trim() == "" || password.trim() == "") {
      return;
    }
    carregando = true;
    //console.log("Username:", username);
    //console.log("Password:", password);
    parametros["usuario"] = username;
    parametros["senha"] = password;
    parametros["token"] = "";

    conexoes = new Conexoes(Constantes.url_base_nutri);
    retorno = await conexoes.conecta(api, parametros);
    if (retorno.sucesso) {
      confirmar = false;
      if (retorno.email_confirmado == 0) {
        carregando = false;

        confirmar = true;
        //console.log("entrou no aguardar store1")
        ConfirmaEmail.set({});
        await esperarMudancaDeEstado(ConfirmaEmail);
        if ($ConfirmaEmail.confirmado == false) {
          //console.log("entrou no aguardar store0")
          confirmar = false;
          ConfirmaEmail.set({});
          return;
        }
        confirmar = false;
        ConfirmaEmail.set({});
        //console.log("entrou no aguardar store")
      }

      //console.log("token " + retorno.token);
      //mensagem = Constantes.msg_login_sucesso;
      localStorage.setItem("token", retorno.token);
      localStorage.setItem("usuario", username);
      localStorage.setItem("id_empresa", retorno.id_empresa);
      localStorage.setItem("id_usuario", retorno.id_usuario);
      ArmazenaVariaveisLogin.atualizarDados(retorno);
      Permissoes.atualizarDados(retorno);
      permissaoUsuario.set(retorno);
      permissaoPlataforma.set(retorno);
      DadosLogin.set(retorno);
      Constantes.logado = true;
      atualizarLogado(true);
      dispatch("logado", true);
      // navigate("/menu");
    } else {
      dispatch("logado", false);
      atualizarLogado(false);
      console.log(retorno);
      if (retorno == "erro") {
        mensagem = Constantes.msg_erro_conexao_generica;
      } else {
        mensagem = Constantes.msg_senha_invalida;
      }
    }
    // Aqui você pode adicionar a lógica para enviar os dados de login para o servidor
  }

  function esqueciSenha() {
    esqueciASenha = true;
  }
</script>

<ModalEsqueciSenha bind:showModal={esqueciASenha} />

<LoadingTela isLoading={carregando} />
{#if confirmar}
  <ModalConfirmaToken email={username} showModal={confirmar} />
{/if}
<CaixaDeDialogo
  message={mensagem}
  on:close={() => {
    conexoes.isLoading = false;
    carregando = false;
  }}
/>
<div class="background">
  
    <div class="form-container">
     <Paper>
      <div class="input-group">
     
        <input
          type="text"
          placeholder="E-mail"
          bind:value={username}
          maxlength="50"
        />
      </div>
      <div class="input-group">
        {#if mostrarSenha}
          <input
            type="text"
            placeholder="Senha"
            bind:value={password}
            maxlength="50"
          />
        {:else}
          <input
            type="password"
            placeholder="Senha"
            bind:value={password}
            maxlength="50"
          />
        {/if}
        <span class="fa fa-eye" on:click={() => (mostrarSenha = !mostrarSenha)}
        ></span>
      </div>

      <button class="btn-login" on:click={handleSubmit}>Login</button><br />
      <!--
      <button class="btn-login btn-outline-azul" on:click={() => esqueciSenha()}
        >Esqueci a senha</button
      >
      <div class="or-divider"></div>
     
        OU
        <button class="btn-google">
            <span class="fa fa-google"></span>
            Logar com Google
        </button>
        
       
      Se ainda não é cadastrado,
      <div class="cadastre-se" on:click={() => (showModal = true)}>
        cadastre-se
      </div>
      -->
      </Paper>
    </div>
  
</div>

<ModalCadastro {showModal} />

<style>
  .form-container {
    max-width: 400px;
    margin: 100px auto;
    text-align: center;
    color: white;
  }

  .input-group {
    position: relative;
    margin-bottom: 1rem;
  }

  .input-group input {
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .input-group .fa-eye {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .btn-login {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #fff;
    background-color: #424242;
    border: 1px solid #141414;
    border-radius: 0.25rem;
    transition:
      color 0.15s ease-in-out,
      background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .btn-google {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #fff;
    background-color: #0e4786;
    border: 1px solid #0f1419;
    border-radius: 0.25rem;
    transition:
      color 0.15s ease-in-out,
      background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .btn-google:hover {
    background-color: #c1351a;
    border-color: #c1351a;
  }

  .or-divider {
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .cadastre-se {
    color: rgb(7, 7, 7);
    text-decoration: underline;
    cursor: pointer;
  }

  .cadastre-se:hover {
    color: darkblue;
  }
  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("/img/back-login.jpg");
    background-size: cover; /* Para cobrir toda a tela */
    background-position: center; /* Para centralizar a imagem */
    background-color: rgba(255, 255, 255, 0.1);
  }
  .btn-outline-azul {
    color: #0b3d72;
    background-color: transparent;
    background-image: none;
    border-color: #0b3d72;
  }
  .btn-outline-azul:hover {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
  }
</style>
